import { controls, grouped } from "../controls";
const assign_auditors = {
  label: "Assign Inspectors",
  pageLabel: "Assign Inspectors", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: false } },
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Bank" }),
    ...controls.oc({ tab: "filter", c: "Bank", placeHolder: "Bank Code", name: "AssignAuditor-bank-bank_code", fastpath: "banks" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "AssignAuditor-bank-bank_display" }),
    ...controls.displayText({ tab: "filter", label: "Branch" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Branch", placeHolder: "Branch Code", name: "AssignAuditor-branch-branch_code", fastpath: "branches", sendToServer: { sendData: [{ varname: 'bank.bank_uid', value: 'AssignAuditor-bank-bank_uid' }] } }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "AssignAuditor-branch-branch_display" }),
    ...controls.displayText({ tab: "filter", label: "User" }),
    ...controls.oc({ tab: "filter", c: "User", placeHolder: "User Code", name: "AssignAuditor-auditor-user_code", fastpath: "users" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "AssignAuditor-auditor-user_display" }),
    ...controls.magicDateLabel({ tab: "filter", label: "From Date", target: "from_date" }),
    ...controls.magicDate({ tab: "filter", name: "from_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "filter", label: "To Date", target: "to_date" }),
    ...controls.magicDate({ tab: "filter", name: "to_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Inspection Master", star: true }),
    ...controls.autoComplete({ tab: "general", name: "inspection_master_code", width: "col-sm-2", controlType: "InspectionMaster" }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Bank", star: true }),
    ...controls.oc({ tab: "general", c: "Bank", placeHolder: "Bank Code", name: "bank_code", isRequired: true, fastpath: "banks", isReadOnly: "edit", clearData: ['branch_code'], hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "bank_display" }),
    ...controls.displayText({ tab: "general", label: "Branch", star: true }),
    ...controls.oc({ tab: "general", length: 4, c: "Branch", placeHolder: "Branch Code", name: "branch_code", isRequired: true, fastpath: "branches", isReadOnly: "edit", sendToServer: { sendData: [{ varname: 'bank.bank_uid', value: 'bank_uid' }] }, hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "branch_display" }),
    ...controls.displayText({ tab: "general", label: "Inspecting Officer", star: true }),
    ...controls.oc({ tab: "general", c: "User", placeHolder: "Inspecting Officer", name: "auditor_code", isRequired: true, fastpath: "users", isReadOnly: "edit", displayData: { user_display: "auditor_display", user_uid: "auditor_uid" }, hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "auditor_display" }),
    ...controls.magicDateLabel({ tab: "general", label: "Deadline", target: "deadline", star: true }),
    ...controls.magicDate({ tab: "general", name: "deadline", dateType: "ontype", isRequired: true, minDate: 'session_date', maxDate: '3 months from now' }),
    ...controls.displayText({ tab: "general", label: "" }),
  ]
  , history: {
    perPage: 10,
    reportHeader: "Assign Inspectors",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "User", accessor: "AssignAuditor-auditor-user_display", },
      { Header: "Bank", accessor: "AssignAuditor-bank-bank_display", },
      { Header: "Branch", accessor: "AssignAuditor-branch-branch_display", },
      { Header: "Deadline", accessor: "deadline", type: 'date' },
    ]
  }
};
export default assign_auditors;